import { authenticateRequest } from '@api/authenticateRequest';

import type { components, operations } from '@type/model';
import type { OmitGroupIdInHeader } from '@type/util';

type UpdateFamilyEventApprovePath =
  operations['AdminEventController_approveEvent']['parameters']['path'];
type UpdateFamilyEventApproveData = components['schemas']['AdminApproveEventDto'];
type UpdateFamilyEventApproveHeaders =
  operations['AdminEventController_approveEvent']['parameters']['header'];

interface UpdateFamilyEventApproveProps {
  path: UpdateFamilyEventApprovePath;
  data: UpdateFamilyEventApproveData;
  headers?: OmitGroupIdInHeader<UpdateFamilyEventApproveHeaders>;
}

type UpdateFamilyEventApproveResponse = unknown;

export async function updateFamilyEventApprove({
  path,
  data,
  headers,
}: UpdateFamilyEventApproveProps): Promise<UpdateFamilyEventApproveResponse | false> {
  const response = await authenticateRequest<UpdateFamilyEventApproveResponse>({
    method: 'patch',
    url: `/api/v1/admin/events/${path.eventId}/approve`,
    headers,
    data,
  });

  console.log('updateFamilyEventApprove', { response });
  return response;
}
